import { gql } from "@urql/core";

const UserDataQry = gql`
  query {
    currentUser {
      id
      fullName
      email
      tenant
      currencyCode
      canSeePrices
    }
  }
`;
const UserDataQryStr = `
  query {
    currentUser {
      id
      fullName
      email
      tenant
      currencyCode
      canSeePrices
    }
  }
`;

export { UserDataQry, UserDataQryStr };
